import { getApiUrl } from '../config'
import AppStore from '../stores/AppStore'

/**
 * Constructs a full API URL using getApiUrl/ENDPOINT_GROUPS configuration as the base.
 * @param {String} selector path or selector used to resolve the base API URL
 * @param {Object} params URL query parameters
 * @returns {String} full URL (including any query parameters) constructed from the selector and params.
 */
export const buildURL = (selector, params) => {
  const RELATIVE = 'x:/' // placeholder, URL must have a valid base provided

  const baseURL = new URL(selector, getApiUrl(selector) || RELATIVE)

  const append = (name, value) => baseURL.searchParams.append(name, value)
  const notEmpty = (value) => value !== null && value !== undefined && value !== ''

  // add query parameters to URL
  if (typeof params === 'object') {
    Object.entries(params)
      .filter((entry) => notEmpty(entry[1]))
      .forEach((entry) => {
        const [name, value] = entry

        if (Array.isArray(value)) {
          value
            .filter((item) => notEmpty(item))
            .forEach((item) => append(name, item))
        } else {
          append(name, value)
        }
      })
  }

  const urlString = baseURL.toString()

  const url = urlString.startsWith(RELATIVE)
    ? urlString.substring(RELATIVE.length - 1)
    : urlString

  return url
}

/**
 * @returns a GET object with Authorization to be used with fetch.
 */
export const getWithAuth = () => ({
  method: 'get',
  headers: {
    Authorization: `Bearer ${AppStore.auth.idToken}`,
    'Content-Type': 'application/json',
  },
})

/**
 * @returns POST or PUT object (if update) to use with fetch.
 * @param {object} body to send
 * @param {boolean} isUpdate TRUE === use PUT else use POST
 */
export const sendWithAuth = (body, isUpdate) => ({
  method: isUpdate ? 'put' : 'post',
  body: JSON.stringify(body),
  headers: {
    Authorization: `Bearer ${AppStore.auth.idToken}`,
    'Content-Type': 'application/json',
  },
})
